import { forwardRef, useEffect, useMemo, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { MDBRow, MDBCol } from "mdbreact";
import { useParams } from "react-router-dom";

import "./FeuD1EstimateFuelConsumption.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { FuelEuDCommonTableColumns } from "../../FeuConstants";
import FormField from "../../../../../common/form/Form";
import { callApi } from "../../../../../services/MonitoringPlanService";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants";

const FeuD1EstimateFuelConsumption = forwardRef(({ D1GhgAndFuelConsumptionData, refetchMonitoringData, dropdownData,vesselMstId }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (D1GhgAndFuelConsumptionData) {
            reset(prev => ({ ...prev, d1: D1GhgAndFuelConsumptionData }));
        }
    }, [D1GhgAndFuelConsumptionData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("d1");
        const payload = {
            ...FuelEuDCommonTableColumns.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };
        try {
            const FeuD1EstimateFuelConsumption = await callApi({
                method: "POST",
                url: API_ROUTES.D1(vesselMstId),
                data: payload,
            });
            if (FeuD1EstimateFuelConsumption?.isSuccess) {
                emitToasterMsg("success", "Table D.1", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, d1: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table D.1", FeuD1EstimateFuelConsumption?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table D.1", error?.errorMessage);
        }
    };

    const monitoringMethodOptions = useMemo(() => {
        if (!dropdownData?.monitoringMethodOptions?.length) return [];
        return [
            { label: "Select method", value: "" },
            ...dropdownData.monitoringMethodOptions.map(({ name, code }) => ({
                label: name,
                value: code,
            })),
        ];
    }, [dropdownData]);

    return (
        <div className="d1-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of method</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Method to be used to estimate fuel consumption
                    </h6>
                </MDBCol>
            </MDBRow>

            {FuelEuDCommonTableColumns.map(({ label, name, maxLength, type }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        {type === "dropdown" ? (
                            <FormField
                                name={`d1.${name}`}
                                type="dropdown"
                                options={monitoringMethodOptions}
                            />
                        ) : (
                            <Controller
                                name={`d1.${name}`}
                                control={control}
                                render={({ field }) => (
                                    <TextArea
                                        id={`d1_${name}`}
                                        className="textarea-resize"
                                        value={field.value || ""}
                                        onChange={field.onChange}
                                        placeholder=""
                                        maxLength={maxLength}
                                        rows={1}
                                    />
                                )}
                            />
                        )}
                    </MDBCol>
                </MDBRow>
            ))}
            <div className="text-center">
                <Button id="feud1_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}>
                    Save
                </Button>
            </div>
        </div>
    );
});

export default FeuD1EstimateFuelConsumption;
